//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const overwrite = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/overwrite/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  

  async function update(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/overwrite/update`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getOrders(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/overwrite/get-orders`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getOrgSite(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/overwrite/get-org-site`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function create(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/overwrite/create`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getReasonDescription(value) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      value = JSON.stringify(value)
      let res = await fetch(`${config.host}/cdr-panel/overwrite/reason-description?query=${value}`, obj);
      return handleResponse(res);
    }
    catch (err) {
      handleError(err)
    }
  }

  async function pointExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/overwrite/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  


  return {
    search,
    update,
    getOrders,
    create,
    getOrgSite,
    getReasonDescription,
    pointExport

  };
};

export default overwrite;
